import sortBy from "lodash/sortBy";

import labels from "./displayFields";

export const RECEIVING_WIZARD_ONLY_FIELDS = [
  "batch_number",
  "billing_type",
  "receiving_report_number",
  "outbound_summary",
  "filter_field2_name",
  "warehouse_name",
  "osd_notes",
  "general_notes",
  "id_cost_center",
  "last_in",
  "last_out",
  "carrier_name",
  "order_number",
  "bol_number",
  "tracking_number",
  "truck_number",
  "manufacture_part_number",
  "expiration_date",
  "expiration_month",
  "expiration_year",
  "expiration_month_day_year",
  "manufacture_date",
  "days_left_to_expire",
  "unit_of_measure",
  "square_footage",
  "square_footage_type",
  "cubic_footage",
  "asset_total_weight",
  "predefined_cubic_feet",
];

export const showReceivingWizardFields = (values = {}) =>
  Boolean(values.receiving_wizard) && !values.onsiteCaptureMode;

export const applyReceivingWizardFieldVisibility = (display, values) => {
  if (!display || showReceivingWizardFields(values)) return display;

  return {
    ...display,
    ...Object.fromEntries(RECEIVING_WIZARD_ONLY_FIELDS.map(field => [field, false])),
  };
};

export const getIdentifiers = values => {
  const includeReceivingWizardFields = showReceivingWizardFields(values);

  return sortBy(
    [
      ["photo", "include", labels.photo],
      ["item_id", "include", labels.item_id],
      ["barcode_number", "include", values.barcode_label || labels.barcode_number],
      ["sku_number", "include", values.sku_number_label || labels.sku_number],
      ...(includeReceivingWizardFields ? [["batch_number", "include", values.batch_number_label || labels.batch_number]] : []),
      ...(includeReceivingWizardFields ? [["billing_type", "include", values.billing_type_label || labels.billing_type]] : []),
      ["attachments", "include", labels.attachments],
      ["item_code", "include", labels.item_code],
      ["serial_number", "descriptive_info", values.serial_number_label || labels.serial_number],
      ...(includeReceivingWizardFields ? [["receiving_report_number", "descriptive_info", labels.receiving_report_number]] : []),
      ...(includeReceivingWizardFields ? [["outbound_summary", "descriptive_info", labels.outbound_summary]] : []),
      ["created_at", "include", labels.created_at],
      ["updated_at", "include", labels.updated_at],
      ...(includeReceivingWizardFields ? [[
        "filter_field2_name",
        "include",
        values.filter_field2 ? `${values.filter_field2} Name` : "Project Name",
      ]] : []),
      ...(includeReceivingWizardFields ? [["warehouse_name", "include", labels.warehouse_name || "Warehouse Name"]] : []),
      // ["billing_category", "include", labels.billing_category],
      ...(includeReceivingWizardFields ? [["osd_notes", "include", labels.osd_notes]] : []),
      ...(includeReceivingWizardFields ? [["general_notes", "include", labels.general_notes]] : []),
      ...(includeReceivingWizardFields ? [["id_cost_center", "include", labels.cost_center]] : []),
      ...(includeReceivingWizardFields ? [["last_in", "warehouse_info", labels.last_in]] : []),
      ...(includeReceivingWizardFields ? [["last_out", "warehouse_info", labels.last_out]] : []),
      ...(includeReceivingWizardFields ? [["carrier_name", "include", values.carrier_name_label || labels.carrier_name]] : []),
      ...(includeReceivingWizardFields ? [["order_number", "include", values.order_number_label || labels.order_number]] : []),
      ...(includeReceivingWizardFields ? [["bol_number", "include", values.bol_number_label || labels.bol_number]] : []),
      ...(includeReceivingWizardFields ? [["tracking_number", "include", values.tracking_number_label || labels.tracking_number]] : []),
      ...(includeReceivingWizardFields ? [["truck_number", "include", values.truck_number_label || labels.truck_number]] : []),
      ["asset_label_pdf", "include", labels.asset_label_pdf],
    ],
    v => v[2]
  );
};

export const getDescriptiveInfo = values => {
  const includeReceivingWizardFields = showReceivingWizardFields(values);

  return sortBy(
    [
      ["description", "descriptive_info", labels.description],
      [
        "description_comments",
        "descriptive_info",
        values.description_comments_label || labels.description_comments,
      ],
      ["manufacturer", "descriptive_info", labels.manufacturer],
      ...(includeReceivingWizardFields ? [[
        "manufacture_part_number",
        "descriptive_info",
        values.manufacture_part_number_label || labels.manufacture_part_number,
      ]] : []),
      ...(includeReceivingWizardFields ? [[
        "expiration_date",
        "descriptive_info",
        values.expiration_date_label || labels.expiration_date,
      ]] : []),
      ...(includeReceivingWizardFields ? [[
        "expiration_month",
        "descriptive_info",
        values.expiration_month_label || labels.expiration_month,
      ]] : []),
      ...(includeReceivingWizardFields ? [[
        "expiration_year",
        "descriptive_info",
        values.expiration_year_label || labels.expiration_year,
      ]] : []),
      ...(includeReceivingWizardFields ? [[
        "expiration_month_day_year",
        "descriptive_info",
        values.expiration_month_day_year_label || labels.expiration_month_day_year,
      ]] : []),
      ...(includeReceivingWizardFields ? [[
        "manufacture_date",
        "descriptive_info",
        values.manufacture_date_label || labels.manufacture_date,
      ]] : []),
      ...(includeReceivingWizardFields ? [["days_left_to_expire", "descriptive_info", labels.days_left_to_expire]] : []),
      ...(includeReceivingWizardFields ? [[
        "unit_of_measure",
        "descriptive_info",
        values.unit_of_measure_label || labels.unit_of_measure,
      ]] : []),
      ...(includeReceivingWizardFields ? [["square_footage", "descriptive_info", values.square_footage_label || labels.square_footage]] : []),
      ...(includeReceivingWizardFields ? [["cubic_footage", "descriptive_info", values.cubic_footage_label || labels.cubic_footage]] : []),
      ...(includeReceivingWizardFields ? [[
        "asset_total_weight",
        "descriptive_info",
        values.asset_total_weight_label || labels.asset_total_weight,
      ]] : []),
  
    ...(includeReceivingWizardFields ? [[
        "predefined_cubic_feet",
        "descriptive_info",
        values.predefined_cubic_feet_label || labels.predefined_cubic_feet,
      ]] : []),
      ["color", "descriptive_info", labels.color],
      ["finishes", "descriptive_info", labels.finishes],
      ["condition", "descriptive_info", labels.condition],
      ["dimensions", "descriptive_info", labels.dimensions],
      ["model", "descriptive_info", values.model_label || labels.model],
      ["unit_cost", "plumbing_info", labels.unit_cost],
      ["category", "include", labels.category],
      ["disposition", "include", labels.disposition],
      ["subcategory", "include", labels.subcategory],
      ["weight", "include", labels.weight],
    ],
    v => v[2]
  );
};

export const getOriginInfo = values =>
  sortBy(
    [
      ["existing_building", "origin_info", labels.existing_building],
      ["existing_floor", "origin_info", labels.existing_floor],
      ["existing_room", "origin_info", labels.existing_room],
      ["origin_room_number", "origin_info", labels.origin_room_number],
      ["origin_cubby_number", "origin_info", labels.origin_cubby_number],
      ["origin_employee_name", "origin_info", labels.origin_employee_name],
      ["quantity", "origin_info", labels.quantity],
      ["origin_comments", "origin_info", labels.origin_comments],
      ["department_name", "origin_info", labels.department_name],
      // ["packing", "origin_info", labels.packing],
    ],
    v => v[2]
  );

// Keep the old export for backward compatibility
export const originInfo = getOriginInfo({});

export const getDestinationInfo = values =>
  sortBy(
    [
      ["new_building", "destination_info", labels.new_building],
      ["new_floor", "destination_info", labels.new_floor],
      ["new_room", "destination_info", labels.new_room],
      ["destination_employee_name", "destination_info", labels.destination_employee_name],
      ["destination_room_number", "destination_info", labels.destination_room_number],
      ["destination_quantity", "destination_info", labels.destination_quantity],
      ["destination_comments", "destination_info", labels.destination_comments],
      // ["destination_number", "destination_info", labels.destination_number],
      ...(values.medical_fields ? [["install_responsibility", "destination_info", labels.install_responsibility]] : []),
    ],
    v => v[2]
  );

export const destinationInfo = getDestinationInfo({});

export const getWarehouseInfo = ({ availableQuantity }) =>
  sortBy(
    [
      ["rack_locations", "warehouse_info", labels.rack_locations],
      ["available_quantity", "warehouse_info", availableQuantity],
      ["quantity_ordered", "warehouse_info", labels.quantity_ordered],
      // ["quantity_received", "warehouse_info", labels.quantity_received],
      ["po_number", "warehouse_info", labels.ii_po_number],
      ["reserved_quantity", "warehouse_info", labels.reserved_quantity],
      ["minimum_quantity", "warehouse_info", labels.minimum_quantity],
      // ["allocated_quantity", "warehouse_info", labels.allocated_quantity],
      // ["in_cart_quantity", "warehouse_info", labels.in_cart_quantity],
      ["warehouse_quantity", "warehouse_info", labels.warehouse_quantity],
      ["pallet_type", "warehouse_info", labels.pallet_type],
      ["unit_type", "warehouse_info", labels.unit_type],
      ["square_footage_type", "warehouse_info", labels.square_footage_type],
    ],
    v => v[2]
  );

export const electricalInfo = [];

export const plumbingInfo = [];

export const mechanicalInfo = [];

export const getMechanicalInfo = () => [];

export const shipments = sortBy(
  [
    ["shipment_id", "shipments", labels.shipment_id],
    ["vendor_name", "shipments", labels.vendor_name],
    ["carrier_name", "shipments", labels.carrier_name],
    ["order_number", "shipments", labels.order_number],
    ["bol", "shipments", labels.bol],
    ["total_weight", "shipments", labels.total_weight],
    ["shipment_notes", "shipments", labels.shipment_notes],
    ["tracking_number", "shipments", labels.tracking_number],
    ["customer_po_number", "shipments", labels.customer_po_number],
    ["total_receiving_units", "shipments", labels.total_receiving_units],
    ["truck_number", "shipments", labels.truck_number],
    ["cost_center", "shipments", labels.cost_center],
  ],
  v => v[2]
);

export const getInventoryItems = values =>
  sortBy(
    [
      ["ii_image", "inventory_items", labels.ii_image],
      ["ii_barcode", "inventory_items", values.barcode_label || labels.ii_barcode],
      ["ii_description", "inventory_items", labels.ii_description],
      ["ii_qtyRequested", "inventory_items", labels.ii_qtyRequested],
      ["ii_po_number", "inventory_items", labels.ii_po_number],
      ["ii_idsr_number", "inventory_items", labels.ii_idsr_number],
      // ["ii_eoc_number", "inventory_items", labels.ii_eoc_number],
      ["ii_location", "inventory_items", labels.ii_location],
      // ["ii_location_address", "inventory_items", labels.ii_location_address],
      ["ii_building", "inventory_items", labels.ii_building],
      ["ii_floor", "inventory_items", labels.ii_floor],
      ["ii_room", "inventory_items", labels.ii_room],
      // ["ii_deliveryDate", "inventory_items", labels.ii_deliveryDate],
      // ["ii_deliveryTime", "inventory_items", labels.ii_deliveryTime],
      ["ii_notes", "inventory_items", labels.ii_notes],
      ["ii_item_id", "inventory_items", labels.item_id],
      ["ii_model", "inventory_items", values.model_label || labels.model],
      ["ii_dimensions", "inventory_items", labels.ii_dimensions],
      ["ii_disposition", "inventory_items", labels.disposition],
      ["ii_sku_number", "inventory_items", labels.sku_number],
    ],
    v => v[2]
  );

export const getInventoryRequest = ({ commentsName, configurableField1Name, configurableField2Name, configurableField3Name, configurableField4Name, configurableField5Name }) =>
  sortBy(
    [
      ["ir_email", "inventory_items", labels.ir_email],
      ["ir_cc_emails", "inventory_items", labels.ir_cc_emails],
      ["ir_work_order_number", "inventory_items", labels.ir_work_order_number],
      ["ir_po_number", "inventory_items", labels.ir_po_number],
      ["ir_location", "inventory_items", labels.ir_location],
      ["ir_location_address", "inventory_items", labels.ir_location_address],
      ["ir_resources", "inventory_items", labels.ir_resources],
      ["ir_comment", "inventory_items", commentsName || labels.ir_comment],
      ["ir_configurable_field_1", "inventory_items", configurableField1Name || labels.ir_configurable_field_1],
      ["ir_configurable_field_2", "inventory_items", configurableField2Name || labels.ir_configurable_field_2],
      ["ir_configurable_field_3", "inventory_items", configurableField3Name || labels.ir_configurable_field_3],
      ["ir_configurable_field_4", "inventory_items", configurableField4Name || labels.ir_configurable_field_4],
      ["ir_configurable_field_5", "inventory_items", configurableField5Name || labels.ir_configurable_field_5],
      ["ir_designer", "inventory_items", labels.ir_designer],
      ["ir_start_date", "inventory_items", labels.ir_start_date],
      ["ir_start_time", "inventory_items", labels.ir_start_time],
      ["ir_end_date", "inventory_items", labels.ir_end_date],
      ["ir_end_time", "inventory_items", labels.ir_end_time],
      ["ir_delivery_date", "inventory_items", labels.ir_delivery_date],
      ["ir_attachments", "inventory_items", labels.ir_attachments],
      ["ir_disposition", "inventory_items", labels.disposition],
      ["ir_contact_name", "inventory_items", labels.ir_contact_name],
      ["ir_contact_phone_number", "inventory_items", labels.ir_contact_phone_number],
      ["ir_picking_notes", "inventory_items", labels.ir_picking_notes],
    ],
    v => v[2]
  );

export const getshoppingCart = ({ projectLabel, quantityLabel, descriptionComments, ...values }) =>
  sortBy(
    [
      ["sc_description", "inventory_items", labels.sc_description],
      ["sc_model", "inventory_items", values.model_label || labels.sc_model],
      ["sc_po_number", "warehouse_info", labels.ii_po_number],
      ["sc_sku_number", "inventory_items", labels.sku_number],
      ["sc_storage_location", "inventory_items", projectLabel || labels.sc_storage_location],
      ["sc_item_id_overlay", "inventory_items", labels.sc_item_id_overlay],
      ["sc_dimensions", "inventory_items", labels.sc_dimensions],
      ["sc_available_qty", "inventory_items", quantityLabel || labels.sc_available_qty],
      // ["sc_price", "inventory_items", labels.sc_price],
      // ["sc_asset_id_overlay", "inventory_items", labels.sc_asset_id_overlay],
      ["sc_manufacture", "inventory_items", labels.sc_manufacture],
      ["sc_color", "inventory_items", labels.sc_color],
      ["sc_condition", "inventory_items", labels.sc_condition],
      ["sc_item_code", "inventory_items", labels.sc_item_code],
      ["sc_expiration", "inventory_items", labels.sc_expiration],
      [
        "sc_description_comments",
        "inventory_items",
        descriptionComments || labels.description_comments,
      ],
    ],
    v => v[2]
  );

export const getOrders = ({ dateName, projectName, configurableField3Name }) =>
  sortBy(
    [
      ["order_work_order_number", "orders", labels.order_work_order_number],
      ["order_requested_at", "orders", labels.order_requested_at],
      ["order_requested_by", "orders", labels.order_requested_by],
      ["order_start_date", "orders", labels.order_start_date],
      ["order_project_name", "orders", projectName || labels.order_project_name],
      ["order_destination", "orders", labels.order_destination],
      ["order_pdf_report", "orders", labels.order_pdf_report],
      ["order_va_status", "orders", labels.order_va_status],
      ["order_comments", "orders", labels.order_comments],
      ["order_release_notes", "orders", labels.order_release_notes],
      ["order_actions", "orders", labels.order_actions],
      ["order_delivery_date", "orders", dateName || labels.order_delivery_date],
      ["order_configurable_field_3", "orders", configurableField3Name || labels.order_configurable_field_3],
    ],
    v => v[2]
  );

export const reservations = sortBy(
  [
    ["reservation_order_number", "reservation", labels.reservation_order_number],
    ["reservation_create_on", "reservation", labels.reservation_create_on],
    ["reservation_age", "reservation", labels.reservation_age],
    ["reservation_for", "reservation", labels.reservation_for],
    // ["reservation_po_number", "reservation", labels.reservation_po_number],
    ["reservation_notes", "reservation", labels.reservation_notes],
    ["reservation_requested_by", "reservation", labels.reservation_requested_by],
    ["reservation_customer_name", "reservation", labels.reservation_customer_name],
    ["reservation_actions", "reservation", labels.reservation_actions],
  ],
  v => v[2]
);
